import { create } from "zustand";
import type { AppSettings } from "@/lib/types";
import {
  DEFAULT_APP_SETTINGS,
  loadAppSettings,
  saveAppSettings,
  syncSettingsWithRemote,
} from "@/lib/settings-storage";

interface AppSettingsState {
  settings: AppSettings;
  isLoaded: boolean;

  // アクション
  loadSettings: () => Promise<void>;
  updateSettings: (settings: Partial<AppSettings>) => Promise<void>;
  // ログイン確定後に呼び、他端末の設定の方が新しければ反映する
  syncFromRemote: () => Promise<void>;
}

export const useAppSettingsStore = create<AppSettingsState>((set, get) => ({
  settings: DEFAULT_APP_SETTINGS,
  isLoaded: false,

  loadSettings: async () => {
    const settings = await loadAppSettings();
    set({ settings, isLoaded: true });
    await get().syncFromRemote();
  },

  updateSettings: async (newSettings) => {
    const { settings } = get();
    const merged = { ...settings, ...newSettings };
    set({ settings: merged });
    await saveAppSettings(merged);
  },

  syncFromRemote: async () => {
    const synced = await syncSettingsWithRemote();
    if (synced.appSettings) {
      set({ settings: synced.appSettings });
    }
  },
}));
